import API from "./index";

class PerfilMenuService {
  constructor() {
    this.pathSistemas = "/api/sgu/sistemas";
    this.pathPerfis = "/api/sgu/sistemas/perfis";
    this.pathPerfilMenu = "/api/sgu/perfilmenu";
  }

  async listSistema({ situacao = 1, indiceInicio = 0, numItens = 5 }) {
    const params = {
      situacao,
      indiceInicio,
      numItens
    };
    return API.get(`${this.pathSistemas}/list`, { params });
  }

  async listPerfil({ codSistema, situacao = 1 }) {
    const params = { codSistema, situacao };
    return API.get(`${this.pathPerfis}/list`, { params });
  }

  async listModuloSistema({ codSistema, situacao = 1 }) {
    return API.get(`/api/sgu/sistemas/${codSistema}/modulos/list`, {
      params: { situacao }
    });
  }

  async listEntidade({ codSistema, codModulo, codPerfil, situacao = 1 }) {
    return API.get(`/api/sgu/sistemas/${codSistema}/modulos/${codModulo}/entidades/${codPerfil}/list`, {
      params: { situacao }
    });
  }


  async salvarPerfilMenu({ codSistema, codPerfil }, payload) {
    return API.post(`/api/sgu/sistemas/${codSistema}/perfis/${codPerfil}/menus/salvar`, payload);
  }
}

export default new PerfilMenuService();
